import { useDashboardData } from '@/common/dashboard/DashboardDataContext';
import { StatCard } from '@/common/dashboard/StatCard';
import { StringUtils } from '@/common/utils/StringUtils';
import { Box } from '@mui/material';

// The tiles sit outside the SpacerLayout so their row fits its content rather than taking a share of the height
export const DemGtnSummaryStats = () => {
  const { data } = useDashboardData();

  const gross = data.rows.find((row) => row.id === 'GROSS_SALES')?.total;
  const deductions = data.rows.find((row) => row.id === 'TOTAL_DEDUCTIONS')?.total;
  const net = data.rows.find((row) => row.id === 'NET_SALES')?.total;

  // Deductions are negative so the summary adds down to Net Sales, while GTN % is shown as a positive rate
  const gtnPct = gross && deductions != null ? -deductions / gross : null;

  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <StatCard
        label="Gross Sales"
        value={StringUtils.formatCompactNumber(gross, { currency: true, accounting: true })}
        description="Total gross sales for the selected products and periods."
      />
      <StatCard
        label="Total Deductions"
        value={StringUtils.formatCompactNumber(deductions, { currency: true, accounting: true })}
        description="Total deductions (rebates, chargebacks, fees, etc.) for the selected products and periods, shown as a negative amount."
      />
      <StatCard
        label="Net Sales"
        value={StringUtils.formatCompactNumber(net, { currency: true, accounting: true })}
        description="Total net sales (gross sales less deductions) for the selected products and periods."
      />
      <StatCard
        label="GTN %"
        value={StringUtils.toPercent(gtnPct, { digits: 1 })}
        description="Total deductions as a percent of gross sales for the selected products and periods."
      />
    </Box>
  );
};
